import { render, staticRenderFns } from "./GlobalPanorama.vue?vue&type=template&id=3a80bf40&"
import script from "./GlobalPanorama.vue?vue&type=script&lang=ts&"
export * from "./GlobalPanorama.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports